/**
 * Which screen the app opens on when it is opened at the main address (Indra, 2026-09-27): the last game's Final Results are kept for
 * the day, but once a new "day" has begun the first screen is the normal start — no need to tap New Game first. A new day begins when
 * the activation code changes: the daily job runs at 21:00 UTC (04:00 in Indonesia), which is also more than a day after anything older.
 * Pure, so it is tested without a clock.
 */

/** The hour (UTC) of the daily job that changes the activation code (wrangler.toml: crons = ["0 21 * * *"]). */
export const CODE_ROTATION_UTC_HOUR = 21;

const DAY_MS = 24 * 60 * 60 * 1000;

/** The most recent moment, at or before `now`, that the activation code changed. */
export function lastCodeRotation(now: number): number {
  const d = new Date(now);
  const today = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), CODE_ROTATION_UTC_HOUR);
  return today <= now ? today : today - DAY_MS;
}

/** True when a game that ended at `endedAt` belongs to an earlier "day": the code has changed since. */
export function endedGameIsStale(endedAt: number, now: number): boolean {
  return endedAt < lastCodeRotation(now);
}
